import React, { createContext, useContext, ReactNode } from 'react'
import { Analytics } from '@npm-client-frontends/shared-utils/analytics'
import { UserAttributes } from './userAttributes'
import { UserAuthSession } from './userAuthSession'

export interface GlobalContextType {
  analytics: Analytics
  amplify: {
    getUserAttributes: () => UserAttributes
    getUserAuthSession: () => UserAuthSession
  }
}

const GlobalContext = createContext<GlobalContextType | undefined>(undefined)

export const useGlobalContext = () => {
  const context = useContext(GlobalContext)
  if (context === undefined) {
    throw new Error(
      'useGlobalContext must be used within a GlobalContextProdiver',
    )
  }

  return context
}

export const useUserAttributes = () => {
  const { amplify } = useGlobalContext()
  return amplify.getUserAttributes()
}

export const useUserAuthSession = () => {
  const { amplify } = useGlobalContext()
  return amplify.getUserAuthSession()
}

export const GlobalContextProvider = ({
  children,
  value,
}: {
  children: ReactNode
  value: GlobalContextType
}) => {
  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  )
}
